/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Project_CompleteInputs */

const en_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project import complete...`)
};

const fr_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du projet terminée...`)
};

const de_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektimport abgeschlossen...`)
};

const it_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto completata...`)
};

const ru_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт проекта завершен...`)
};

const es_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación del proyecto completada...`)
};

const zh_cn2_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目导入完成……`)
};

const ja_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポートが完了しました...`)
};

const hi_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट का आयात पूरा हो गया...`)
};

const pt_pt2_work_order_import_status_project_complete = /** @type {(inputs: Work_Order_Import_Status_Project_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação do projeto concluída...`)
};

/**
* | output |
* | --- |
* | "Project import complete..." |
*
* @param {Work_Order_Import_Status_Project_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_project_complete = /** @type {((inputs?: Work_Order_Import_Status_Project_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Project_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_status_project_complete(inputs)
	if (locale === "de") return de_work_order_import_status_project_complete(inputs)
	if (locale === "it") return it_work_order_import_status_project_complete(inputs)
	if (locale === "ru") return ru_work_order_import_status_project_complete(inputs)
	if (locale === "es") return es_work_order_import_status_project_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_status_project_complete(inputs)
	if (locale === "ja") return ja_work_order_import_status_project_complete(inputs)
	if (locale === "hi") return hi_work_order_import_status_project_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_status_project_complete(inputs)
	return en_work_order_import_status_project_complete(inputs)
});